/**
 * What starts a graph when someone reaches the company, rather than when an
 * event asks the company to reach someone.
 *
 * Not a `Trigger` row and not a webhook: an inbound conversation is matched by
 * direction, so there is nothing to look up. A graph names it the same way it
 * names any other trigger, by this event name.
 */
export const INCOMING_COMMUNICATION_EVENT_NAME = 'communication.incoming';
export const WEBHOOK_TRIGGER_CATALOG = [
    {
        triggerType: 'LEAD_WEBHOOK',
        eventName: 'lead.received',
        triggerId: 'webhook-lead',
        name: 'Lead',
    },
    {
        triggerType: 'PAYMENT_OVERDUE_WEBHOOK',
        eventName: 'payment.overdue',
        triggerId: 'webhook-payment-overdue',
        name: 'Collections',
    },
];
export const WEBHOOK_TRIGGER_TO_EVENT = Object.fromEntries(WEBHOOK_TRIGGER_CATALOG.map(e => [e.triggerType, e.eventName]));
export const WEBHOOK_EVENT_TO_TRIGGER = Object.fromEntries(WEBHOOK_TRIGGER_CATALOG.map(e => [e.eventName, e.triggerType]));
export const WEBHOOK_TRIGGER_ID_BY_TYPE = Object.fromEntries(WEBHOOK_TRIGGER_CATALOG.map(e => [e.triggerType, e.triggerId]));
//# sourceMappingURL=trigger-catalog.js.map